import {
  FindYourPathData,
  FindYourPathVariant,
  FindYourPathTestResult,
  UseFindYourPath,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "findYourPath";

const useFindYourPath: UseFindYourPath = () => {
  const { isLoading, value } = useMonarchRule<{
    data: FindYourPathData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    } as FindYourPathTestResult;
  }

  const { data } = value;

  // Determine variant based on sections data
  let variant: FindYourPathVariant = "control";
  if (data?.sections !== undefined) {
    variant = data.sections.length === 0 ? "emptyState" : "customConfig";
  } else if (data?.variant) {
    variant = data.variant;
  }

  return {
    isLoading: false,
    variant,
    data,
  };
};

export default useFindYourPath;
